export default "__VITE_ASSET__CArnaXVZ__"